module.exports = __webpack_public_path__ + "static/media/p&s.81b0f7e7.jpeg";